import React from 'react'

import Header from 'components/Header'

import { Container } from './styles'
import Layout from 'layouts/Logged'
import NotificationTemplate from 'features/notifications'

const Notifications: React.FC = () => {
  /*
  |-----------------------------------------------------------------------------
  | Renders
  |-----------------------------------------------------------------------------
  |
  |
  */
  return (
    <Layout>
      <Container>
        <Header
          title="Notificações"
          subTitle="Crie notificações para os alunos Mentoria."
        />

        <NotificationTemplate />
      </Container>
    </Layout>
  )
}

export default Notifications
